import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
};

const SearchBox: React.FC<Props> = ({ search, setSearch }) => {
  return (
    <div className="flex gap-[10px]">
      <span className="relative">
        <SearchIcon />
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="rounded-[10px] border-[1px] border-[#ababab] text-[13px] p-[13px] pl-[35px]"
          placeholder="Search"
        />
      </span>
      <Link
        to="/admin-management/create-admin"
        className="text-white bg-orange py-[13px] height-auto px-[37px] rounded-[10px] text-[14px] flex gap-[10px] items-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="currentColor"
          className="size-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 4.5v15m7.5-7.5h-15"
          />
        </svg>
        <span>Create Admin</span>
      </Link>
    </div>
  );
};

export default SearchBox;

const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className="size-4 absolute top-[18px] left-[15px] text-[#ababab]"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
      />
    </svg>
  );
};
